// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1e_OG","buttons":"SendReceipts_buttons__1E_ol","email":"SendReceipts_email__xS3fB","bookApptTitle":"SendReceipts_bookApptTitle__1Qnr5"};